import * as React from 'react';
import { style } from 'typestyle';
import { TabStyles } from '@tableau/widgets';
import { Messages } from '../../gen-src/Localize';

export const EmptyTimeSeries: () => JSX.Element = () => {
  return (
    <div className={containerStyle}>
      <p style={messageStyle}>{Messages.timelineUnavailable()}</p>
    </div>
  );
};

const containerStyle: string = style({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  textAlign: 'center',
  borderWidth: TabStyles.Sizing.BorderWidth,
  borderStyle: 'solid',
  borderColor: 'rgb(216, 216, 216)',
  height: '100%',
});

const messageStyle: React.CSSProperties = {
  margin: '16px',
  fontWeight: 'normal',
  fontSize: TabStyles.Typography.Sizing.XLarge,
  color: TabStyles.Colors.F8,
};
